import SignatureCanvas from 'react-signature-canvas';
import html2canvas from 'html2canvas';
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { useRef, useState } from "react";
import { useMemo } from "react";
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import SignEncounter from '../../SignEncounter';
import ShowItemContent from './ShowItemContent';

const Signature = ({ item, setItem, activeAccordion, validations, isGroupNote, ...props }) => {
    const { patientName = 'Patient',
        // activeTab, setActiveTab, 
        // setSearchParam, 
        // setIsSign, 
        // setIsLoading, 
        // getSaveData
    } = props;
    const { setItemWithFile, handleRemoveFile, handleSetSelectedDateSign } = useNewItemChange(setItem, 'Viewer', activeAccordion);

    console.log("idxaa", item.ItemID)
    const [isSign, setIsSign] = useState(false);

    return (
        <>
            <SignEncounter
                isSign={isSign}
                setIsSign={setIsSign}
                // providerName={initialData?.Data?.ProviderFirstName || '' } 
                providerName={patientName} // Patient Name
                setSearchParam={() => { }}
                getSaveData={setItemWithFile}
                item={item}
                isOpenedFrom={'PatientIntakeForm'}
            />
            <div className='content-box d-flex gap-10'>
                <p className={`text text-black min-w-231px d-flex justify-content-end gap-01 text-end  ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                    {/* {item.content || '[Enter prompt or question]'} */}
                    {ShowItemContent(item, isGroupNote)}
                    {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
                </p>
                <div className="position-relative sign-here-box cursor-pointer d-flex align-items-center justify-content-center w-100">
                    {item.file ?
                        <>
                            <img
                                src={`data:image/png;base64,${item.file}`}
                                style={{ maxHeight: '81px' }}
                                alt="Uploaded preview" />
                            <span className="cross-icon d-flex" onClick={() => handleRemoveFile(item)}>
                                <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                            </span>
                        </>
                        :
                        <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => setIsSign(true)}>Sign here</div>}
                </div>
            </div>
        </>
    );
};

export default Signature